import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		body: {
			padding: 20
		},
		typography: {
			textTransform: "capitalize"
		},
		boldText: {
			fontWeight: "bold"
		},
		button: {
			marginLeft: 5,
			marginRight: 5
		}
	} satisfies Record<string, CSSObject>);
};